import { identifiers } from 'utils/constants/identifiers';
import { fetchFromStorage } from 'utils/storage';

const Currency = (amount: number) => {
  const cur = JSON.parse(fetchFromStorage(identifiers.currency) as any);
  return new Intl.NumberFormat(cur?.currencyLocale?.replace(/_/g, '-') || 'en-In', {
    style: 'currency',
    currency: cur?.currency || 'INR',
  }).format(amount);
};

export default Currency;
